<template>
  <div class="order-page">
    <Row>
      <i-Col span="3" align="left" >
        <Input v-model="search1" :placeholder="$t('monitor.Order.orderNo')"></Input>
      </i-Col>
      <i-Col span="3" align="left" >
        <Input v-model="search2" :placeholder="$t('monitor.Order.salesman')">
        </Input>
      </i-Col>
      <i-Col span="3" align="left" />
        <DatePicker @on-change="entryTimeChange1" :value="selectTime1" :placeholder="$t('monitor.Order.please_enter_date1')"></DatePicker>
      </i-Col>
      <i-Col span="3" align="left" />
        <DatePicker @on-change="entryTimeChange2" :value="selectTime2" :placeholder="$t('monitor.Order.please_enter_date2')"></DatePicker>
      </i-Col>
      <i-Col span="3" align="left" />
        <Button icon="ios-search" @click="handleSearch()"></Button>
        <Button icon="refresh" @click="handleReset()"></Button>
      </i-Col>
    </Row>
    <Table class="order-table" highlight-row stripe border :columns="columns" v-if="check === false" :data="datas"></Table>
    <Table class="order-table" highlight-row stripe border :columns="columns" v-if="check === true" :data="temp"></Table>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'Collector',
  data () {
    return {
      columns: [
        { type: 'index', title: this.$t('monitor.Order.index'), width: 65 },
        { title: this.$t('monitor.Order.orderNo'), key: 'orderNo' },
        { title: this.$t('plan.Production.productName'), key: 'productName' },
        { title: this.$t('monitor.Order.producNo'), key: 'producNo' },
        { title: this.$t('monitor.Order.salesman'), key: 'salesman' },
        { title: this.$t('monitor.Order.ordersTime'), key: 'ordersTime' },
        { title: this.$t('monitor.Order.output'), key: 'output' },
        { title: this.$t('monitor.Order.today'), key: 'today' },
        { title: this.$t('monitor.Order.num'), key: 'num' },
        { title: this.$t('monitor.Order.unit'), key: 'unit', width: 70 },
        // { title: '机台数', key: 'count' },
        { title: this.$t('monitor.Order.countdata'),
          key: 'countdata',
          width: 85,
          render: (h, params) => {
            if (this.datas[params.index].count === 0) {
              return h('a', this.datas[params.index].count)
            } else {
              return h('Poptip', {
                props: {
                  trigger: 'hover',
                  placement: 'left'
                }
              }, [
                h('Tag', this.datas[params.index].count),
                h('div', {
                  slot: 'content'
                }, [
                  h('table', [
                    h('thead', [
                      h('tr', [
                        h('th', this.$t('monitor.Order.name')),
                        h('th', this.$t('monitor.Order.rpm')),
                        h('th', this.$t('monitor.Order.workType')),
                        h('th', this.$t('monitor.Order.worker'))
                      ])
                    ]),
                    h('tbody', this.datas[params.index].countdata.map(item => {
                      return h('tr', [
                        h('td', item.deviceName),
                        h('td', item.rpm),
                        h('td', item.workType),
                        h('td', item.worker)
                      ])
                    }))
                  ])
                ])
              ])
            }
          }
        },
        // { title: this.$t('monitor.Order.DailyOutput'), key: 'DailyOutput' },
        // { title: 'm', key: 'deliveryTime' },
        { title: this.$t('monitor.Order.fastestdelivery'), key: 'fastestdelivery' },
        { title: this.$t('monitor.Order.deliveryTime'), key: 'deliveryTime' }
      ],
      datas: [],
      Producting: [],
      SystemCode: '',
      collectors: [],
      outputdata1: [],
      temp: [],
      selectTime1: '',
      selectTime2: '',
      search1: '',
      search2: '',
      check: false,
      DailyData: []
    }
  },
  methods: {
    loadData () {
      Api.system.get().then(res => {
        this.SystemCode = res.company.systemCode
        // console.log(this.SystemCode)
      })
      let code = '{"systemcode":"' + this.SystemCode + '"}'
      // console.log(code)
      Api.monitor.producting(code).then(res => {
        this.Producting = res.datas
        // console.log(res)
      })
      // console.log(this.Producting)
      Api.monitor.collectors().then(res => {
        this.collectors = res.collectors
      })
      Api.data.DailyData().then(res => {
        for (let i = 0; i < res.datas.length; i++) {
          this.DailyData[res.datas[i].orderProductID] = {}
          this.DailyData[res.datas[i].orderProductID].output = res.datas[i].output
          this.DailyData[res.datas[i].orderProductID].today = res.datas[i].today
        }
        // console.log(this.DailyData)
      })
      Api.monitor.orders().then(res => {
        this.datas = res.datas
        for (let i = 0; i < this.datas.length; i++) {
          let fastestdelivery = false
          let output = 0
          // let today = 0
          if (this.DailyData[this.datas[i].id] === undefined) {
            this.DailyData[this.datas[i].id] = {}
            this.DailyData[this.datas[i].id].today = 0
            this.DailyData[this.datas[i].id].output = 0
          }
          // console.log(this.DailyData[this.datas[i].id], 1)
          if (this.datas[i].unit === 1) {
            this.datas[i].today = this.DailyData[this.datas[i].id].today
            this.datas[i].unit = this.$t('monitor.Order.Meter')
            this.datas[i].output = this.datas[i].output.toFixed(2)
            output = this.datas[i].output
            let percentage = 0
            if (this.datas[i].output !== 0) {
              percentage = this.datas[i].output / this.datas[i].num * 100
            }
            this.datas[i].output += '(' + percentage.toFixed(0) + '%)'
            if (percentage >= 100) {
              fastestdelivery = true
            }
          } else if (this.datas[i].unit === 2) {
            this.DailyData[this.datas[i].id].output = this.DailyData[this.datas[i].id].output * 1.0936
            this.DailyData[this.datas[i].id].output = this.DailyData[this.datas[i].id].output.toFixed(2)
            this.datas[i].today = this.DailyData[this.datas[i].id].today * 1.0936
            this.datas[i].today = this.datas[i].today.toFixed(0)
            this.datas[i].unit = this.$t('monitor.Order.Yard')
            this.datas[i].output = this.datas[i].output * 1.0936
            this.datas[i].output = this.datas[i].output.toFixed(2)
            output = this.datas[i].output
            let percentage = 0
            if (this.datas[i].output !== 0) {
              percentage = this.datas[i].output / this.datas[i].num * 100
            }
            this.datas[i].output += '(' + percentage.toFixed(0) + '%)'
            if (percentage >= 100) {
              fastestdelivery = true
            }
          } else if (this.datas[i].unit === 3) {
            // console.log(this.DailyData[this.datas[i].id], this.datas[i].id, this.DailyData[this.datas[i].id].output)
            this.DailyData[this.datas[i].id].output = this.DailyData[this.datas[i].id].output / (144.0 * 0.9144)
            this.DailyData[this.datas[i].id].output = this.DailyData[this.datas[i].id].output.toFixed(2)
            // console.log(this.DailyData[this.datas[i].id], this.datas[i].id, this.DailyData[this.datas[i].id].output)
            this.datas[i].today = this.DailyData[this.datas[i].id].today / (144.0 * 0.9144)
            this.datas[i].today = this.datas[i].today.toFixed(0)
            this.datas[i].unit = this.$t('monitor.Order.Gross')
            this.datas[i].output = this.datas[i].output / (144.0 * 0.9144)
            this.datas[i].output = this.datas[i].output.toFixed(2)
            output = this.datas[i].output
            let percentage = 0
            if (this.datas[i].output !== 0) {
              percentage = this.datas[i].output / this.datas[i].num * 100
            }
            this.datas[i].output += '(' + percentage.toFixed(0) + '%)'
            if (percentage >= 100) {
              fastestdelivery = true
            }
          }
          if (fastestdelivery === true) {
            this.datas[i].fastestdelivery = this.$t('monitor.Order.completed')
          } else {
            if (this.DailyData[this.datas[i].id] !== undefined && Number(this.DailyData[this.datas[i].id].output) !== 0) {
              let sum
              sum = this.datas[i].num - output
              sum = Math.ceil(sum / this.DailyData[this.datas[i].id].output)
              let Today = new Date()
              Today.setDate(Today.getDate() + sum)
              this.datas[i].fastestdelivery = Today.getFullYear() + '-' + (Today.getMonth() + 1) + '-' + Today.getDate()
            } else {
              this.datas[i].fastestdelivery = this.datas[i].deliveryTime
            }
          }
          let timestamp = new Date(this.datas[i].deliveryTime).getTime()
          this.datas[i].timestamp = timestamp
          let d = []
          let sum = 0
          let count = 0
          // let count = 0
          // console.log(this.Producting, 1)
          if (this.Producting !== null) {
            for (let j = 0; j < this.Producting.length; j++) {
              if (this.datas[i].id === this.Producting[j].id) {
                // for (let t = 0; t < this.outputdata1.length; t++) {
                //   if (this.Producting[j].deviceid === this.outputdata1[t].id) {
                //     sum += this.outputdata1[t].output
                //     // count++
                //     // console.log(sum, count)
                //   }
                // }
                let RPM = 0
                let Type = ''
                let work = ''
                count++
                for (let t = 0; t < this.collectors.length; t++) {
                  if (this.collectors[t].deviceNo === this.Producting[j].deviceNo) {
                    RPM = this.collectors[t].rpm
                    Type = this.collectors[t].workType
                    work = this.collectors[t].worker
                  }
                }
                d.push({
                  deviceNo: this.Producting[j].deviceNo,
                  deviceName: this.Producting[j].deviceName,
                  rpm: RPM,
                  workType: Type,
                  worker: work
                })
              }
            }
          }
          this.datas[i].count = count
          // console.log(sum, count)
          if (sum === 0) {
            this.datas[i].DailyOutput = 0
          } else {
            this.datas[i].DailyOutput = sum
            // console.log(this.datas[i].DailyOutput, '1')
          }
          this.datas[i].countdata = d
          // console.log(this.datas[i].DailyOutput)
        }
        // console.log(this.datas)
        this.temp = []
        if (this.check === true) {
          let d1 = []
          let d2 = []
          let d3 = []
          if (this.search1 !== '') {
            for (let i = 0; i < this.datas.length; i++) {
              if (this.datas[i].orderNo.toLowerCase().indexOf(this.search1.toLowerCase()) !== -1) {
                d1.push(this.datas[i])
              }
            }
          } else {
            d1 = this.datas
          }
          if (this.search2 !== '') {
            for (let i = 0; i < d1.length; i++) {
              if (this.datas[i].salesman.toLowerCase().indexOf(this.search2.toLowerCase()) !== -1) {
                d2.push(d1[i])
              }
            }
          } else {
            d2 = d1
          }
          if (this.selectTime1 !== '') {
            let timestamp = new Date(this.selectTime1).getTime()
            for (let i = 0; i < d2.length; i++) {
              if (timestamp <= d2[i].timestamp) {
                d3.push(d2[i])
              }
            }
          } else {
            d3 = d2
          }
          if (this.selectTime2 !== '') {
            let timestamp = new Date(this.selectTime2).getTime()
            for (let i = 0; i < d3.length; i++) {
              if (timestamp >= d3[i].timestamp) {
                this.temp.push(d3[i])
              }
            }
          } else {
            this.temp = d3
          }
        }
      })
    },
    handleSearch () {
      this.check = true
      this.loadData()
    },
    handleReset () {
      this.check = false
      this.selectTime1 = ''
      this.selectTime2 = ''
      this.search1 = ''
      this.search2 = ''
      this.loadData()
    },
    entryTimeChange1 (v) {
      this.selectTime1 = v
    },
    entryTimeChange2 (v) {
      this.selectTime2 = v
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.loadData()
    }, 2000)
  },
  destroyed () {
    clearInterval(this.timer)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => { vm.loadData() })
  }
}
</script>
<style scoped>
  .order-page {
    padding: 10px;
    min-height: 500px;
    text-align: left;
  }
  .order-table {
    margin-top: 20px;
  }
</style>





// WEBPACK FOOTER //
// Order.vue?99ddb0f0